@if (hasNews) {
  <ul class="card-body-list">
    @for (news of visibleNews; track news) {
      <li>
        <otcx-news-entry [newsEntry]="news"></otcx-news-entry>
      </li>
    }
  </ul>
  @if (isExpandable) {
    <div class="card-footer-expand" data-test="footer">
      <button (click)="toggleExpand()" class="btn btn-primary btn-icon-text">
        <span [ngClass]="isExpanded ? 'icon-pfeil-oben': 'icon-pfeil-unten'"
        class="library-bekb-icon-font"></span>{{isExpanded ? "Weniger anzeigen" : showAllLabel}}
      </button>
    </div>
  }
}
